import { CeruleanButton } from 'components/Button'
import styled from 'styled-components'
import { color, screenWidth } from 'utils'

export const Wrapper = styled.div`
  width: 30rem;

  @media only screen and (max-width: ${screenWidth('sm')}) {
    width: auto;
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 1.5rem 2.5rem 2.5rem 2.5rem;
`

export const Img = styled.img`
  width: 480px;
  height: 186px;

  @media only screen and (max-width: ${screenWidth('sm')}) {
    width: 100%;
  }
`

export const Title = styled.h2`
  color: ${color('title')};
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 150%;
`

export const Description = styled.p`
  color: ${color('title')};
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin: 0 0 2.5rem 0;
`

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  gap: 2rem;
`

export const Button = styled(CeruleanButton)`
  background: ${color('primary')};
  border-radius: 0.5rem;
  color: ${color('white')};
  flex: 1;
`

export const BackButton = styled(Button)`
  background: ${color('white')};
  color: ${color('primary')};
  border: 1px solid ${color('grey100')};

  &:hover:not([disabled]) {
    background: ${color('blue000')};
  }
`
